import React, {lazy, Suspense} from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter, Route, Routes} from 'react-router-dom'

import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module/dist/TagManager.js'

import {isDebug} from 'react-lf-tools'

import Loading from './components/loadingPage/LoadingPage.jsx'
import ItemBag from './pages/itemBag/ItemBag.jsx'
import ShoppingCart from './pages/shoppingCart/ShoppingCart.jsx'
import Login from './pages/login/Login.jsx'
import Logs from './pages/logs/Logs.jsx'
/*import Error from './components/error/Error.jsx'*/

import './index.scss'
import './logger'

const analitycs = () => {
    try {
        ReactGA.initialize(import.meta.env.VITE_ANALYTICS_BITBAR)
        if (!!import.meta.env.VITE_PIXEL)
            ReactPixel.init(import.meta.env.VITE_PIXEL)
        if (!!import.meta.env.VITE_GTM)
            TagManager.initialize({gtmId: import.meta.env.VITE_GTM})
        if (!!import.meta.env.VITE_ADS || !!import.meta.env.VITE_UA)
            ReactGA.initialize([
                {trackingId: import.meta.env.VITE_ADS},
                {trackingId: import.meta.env.VITE_UA}
            ])
    } catch (e) {
        console.error(e)
    }
}

const checkUpdates = () => {
    try {
        if (!isDebug('5173')) if ('serviceWorker' in navigator) {
            const path = (!!import.meta.env.VITE_BASE) ? `/${import.meta.env.VITE_BASE}/sw.js` : `/sw.js`
            navigator.serviceWorker.register(path)
                .then((registration) => {
                    console.log('Service Worker registrado com sucesso!')

                    registration.addEventListener('updatefound', () => {
                        const newWorker = registration.installing
                        if (newWorker) {
                            newWorker.addEventListener('statechange', () => {
                                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                    if (confirm('Uma nova versão está disponível. Atualizar agora?')) {
                                        window.location.reload()
                                    }
                                }
                            })
                        }
                    })
                })
                .catch((error) => {
                    console.error('Erro ao registrar o Service Worker main.js:', error)
                })
        }
    } catch (e) {
        console.error(e.message)
    }
}

analitycs()

checkUpdates()

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const Home = lazy(() =>
    delay(500).then(() => import('./pages/home/Home.jsx'))
)

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter basename={(!!import.meta.env.VITE_BASE) ? `/${import.meta.env.VITE_BASE}` : `/`}>
        {/*<Sentry.ErrorBoundary fallback={<Error/>}>*/}
        <Suspense fallback={<Loading/>}>
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='/produto' element={<ItemBag/>}/>
                <Route path='/sacola' element={<ShoppingCart/>}/>
                <Route path='/login' element={<Login/>}/>
                <Route path='/logs' element={<Logs/>}/>
            </Routes>
        </Suspense>
        {/*</Sentry.ErrorBoundary>*/}
    </BrowserRouter>
)

